export const TRANSLATIONS_NAMESPACE = 'jbp-training-centre'

export const TRANSLATION_KEYS = {
  btnText: `${TRANSLATIONS_NAMESPACE}-btn-text`,
  title: `${TRANSLATIONS_NAMESPACE}-title`,
  noData: `${TRANSLATIONS_NAMESPACE}-no-data`,
  watchVideo: `${TRANSLATIONS_NAMESPACE}-video`,
  slides: `${TRANSLATIONS_NAMESPACE}-slides`,
  search: `${TRANSLATIONS_NAMESPACE}-search`,
}
